// iOS Safari: a tap inside a scrollable QScrollArea needed two taps (Quasar issue #16210). On the first touch
// QScrollArea's mouseenter shows the scrollbar at once; Safari then drops the click of that tap. Quasar v2.12.8 fixed
// it by delaying that on iOS (PR #16211); Quasar v1 never got the fix, so the same change is applied here to the
// v1 component before any QScrollArea exists. Remove when upgrading to Quasar v2.
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';import Platform from 'quasar/src/plugins/Platform.js';;
var methods = QScrollArea.options.methods;

methods.__mouseEnter = function () {
  var _this = this;

  clearTimeout(this.__iosHoverTimer);
  this.__iosHoverTimer = setTimeout(function () {
    _this.__iosHoverTimer = null;
    _this.hover = true;
  }, Platform.is.ios === true ? 50 : 0);
};

methods.__mouseLeave = function () {
  clearTimeout(this.__iosHoverTimer);
  this.__iosHoverTimer = null;
  this.hover = false;
};

export default (function () {});